import { sf_loaidichvu } from '../../models/response/dich-vu/sf_loaidichvu';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_LOAI_DICH_VU_PATH = "loai-dich-vu";

class LoaiDichVuApi extends BaseCRUDApi<sf_loaidichvu> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
}
export const loaiDichVuApi = new LoaiDichVuApi(API_LOAI_DICH_VU_PATH);
